export const defaultRole = {
    ADMIN: 'ROLE_ADMIN',
    GAUGER: 'ROLE_DEALER_MEASURER',
    WORKER: 'ROLE_AREA_WORKER',
    BRIGADIER: 'ROLE_AREA_BRIGADIER',
    MASTER: 'ROLE_AREA_MASTER',
};
